import React, { useContext } from "react";
import { withRouter } from "react-router-dom";
import { UserContext } from "../userContext";
import { auth, googleProvider, db } from "../firebase";

const Login = ({ history }) => {
  const { setUser } = useContext(UserContext).user;

  auth.onAuthStateChanged((user) => {
    if (user) {
      setUser(user);
      localStorage.setItem("egram-user", JSON.stringify(user));
      db.collection("users")
        .doc(user.email)
        .get()
        .then((doc) => {
          if (doc.exists) {
            db.collection("users").doc(user.email).update({
              isOnline: true,
            });
          } else {
            db.collection("users").doc(user.email).set({
              name: user.displayName,
              photo: user.photoURL,
              isOnline: true,
            });
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });

      return history.push("/dashboard");
    }
  });

  const SignInWithPopup = async () => {
    await auth.signInWithPopup(googleProvider);
  };

  const SignInWithRedirect = async () => {
    await auth.signInWithRedirect(googleProvider);
  };

  return (
    <div className="login">
      <h2>Sign In with </h2>
      <button
        className="login__signInBtn google desktop"
        onClick={SignInWithPopup}
      >
        <i className="fa fa-google"></i>
      </button>
      <button
        className="login__signInBtn google mobile"
        onClick={SignInWithRedirect}
      >
        <i className="fa fa-google"></i>
      </button>
      <h2>To Start Chatting </h2>
    </div>
  );
};

export default withRouter(Login);
